import { useEffect, useState } from "react";

import clean1 from "../assets/images/c1.webp";
import clean2 from "../assets/images/c2.webp";
import clean3 from "../assets/images/c3.webp";
import clean4 from "../assets/images/c4.webp";
import clean5 from "../assets/images/c5.webp";
import clean6 from "../assets/images/c6.webp";
import clean7 from "../assets/images/c7.webp";
import clean8 from "../assets/images/c10.webp";
import clean9 from "../assets/images/c9.webp";

const images = [
  { src: clean1, title: "Washroom Cleaning" },
  { src: clean2, title: "Room Cleaning" },
  { src: clean3, title: "Hall Cleaning" },
  { src: clean4, title: "Kitchen Cleaning" },
  { src: clean5, title: "Terrace Cleaning" },
  { src: clean6, title: "Water Tank Cleaning" },
  { src: clean7, title: "Balcony Cleaning" },
  { src: clean8, title: "Parking Area" },
  { src: clean9, title: "Stairs Cleaning" },
];

export default function Aslider() {
  const [active, setActive] = useState(0);
  const [zoomImg, setZoomImg] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* SLIDER */}
      <section className="w-full overflow-hidden py-25 bg-[#f0f8ff]">
        <h1 className="text-3xl md:text-5xl text-center font-bold text-[#e58505] mb-10">
          Trusted Cleaning Services
        </h1>

        <div className="relative flex justify-center items-center h-[250px] sm:h-[250px] md:h-[360px]">
          {images.map((item, index) => {
            const total = images.length;
            let pos = index - active;

            if (pos < -Math.floor(total / 2)) pos += total;
            if (pos > Math.floor(total / 2)) pos -= total;

            const isCenter = pos === 0;

            return (
              <div
                key={index}
                className="absolute transition-all duration-700 ease-in-out"
                style={{
                  transform: `translateX(${pos * 260}px) scale(${isCenter ? 1.05 : 0.9})`,
                  zIndex: isCenter ? 20 : 10 - Math.abs(pos),
                  opacity: Math.abs(pos) > 3 ? 0 : 1,
                }}
              >
                {/* CARD */}
                <div
                  onClick={() => setZoomImg(item.src)}
                  className="
                    bg-white
                    rounded-xl
                    shadow-lg
                    overflow-hidden
                    cursor-pointer
                    relative
                    flex items-center justify-center
                    w-[200px] h-[220px]
                    sm:w-[220px] sm:h-[280px]
                    md:w-[240px] md:h-[320px]
                    transition-transform duration-300
                    hover:scale-[1.03]
                  "
                >
                  {/* IMAGE */}
                  <img
                    src={item.src}
                    alt={item.title}
                    className="
                      w-full h-full
                      object-cover
                      rounded-xl

                      transition-transform duration-300
                      hover:scale-110
                      select-none
                    "
                  />

                  {/* TITLE OVER IMAGE */}
                  <div className="absolute bottom-2 left-2 right-2 bg-[#f0f8ff] backdrop-blur-sm text-[#e58505] text-sm md:text-base font-semibold text-center py-1.5 rounded-lg">
                    {item.title}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* ZOOM MODAL */}
      {zoomImg && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4"
          onClick={() => setZoomImg(null)}
        >
          <img
            src={zoomImg}
            alt="Zoom View"
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
          />
        </div>
      )}
    </>
  );
}
